<div> {{ title }} </div>
<div> Uh oh - - that's a 404 </div>
<div>

    <a class="internal-link" data-link="true" href="/home"> go home </a>

</div>